import React from 'react';
import { Box } from '@wix/design-system';
import clsx from 'clsx';
import { ProgressLoaderProvider } from '../../headless/ProgressLoader';
import styles from './ProgressLoader.scss';
export function ProgressLoader(_ref) {
  let {
    isLoading,
    totalCount = 20,
    progressUpdateInterval = 100,
    countUpdateInterval = 200,
    progressIncrement = 2,
    countIncrement = 1,
    statusMessageCount = 1,
    onAnimationComplete,
    className,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ProgressLoaderProvider, {
    isLoading: isLoading,
    totalCount: totalCount,
    progressUpdateInterval: progressUpdateInterval,
    countUpdateInterval: countUpdateInterval,
    progressIncrement: progressIncrement,
    countIncrement: countIncrement,
    statusMessageCount: statusMessageCount,
    onAnimationComplete: onAnimationComplete
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, className)
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "24px",
    align: "center",
    width: "100%"
  }, children)));
}
//# sourceMappingURL=ProgressLoader.js.map